import type { ReactNode, RefObject } from "react";

import { FloatingPanelShell } from "@/components/sdk-shells";

interface FloatingControlsHelpPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerRef?: RefObject<HTMLElement | null>;
  title: string;
  children: ReactNode;
  panelWidthPx?: number;
  panelHeightPx?: number;
  offsetX?: number;
  offsetY?: number;
}

export function FloatingControlsHelpPanel({
  open,
  onOpenChange,
  triggerRef,
  title,
  children,
  panelWidthPx = 200,
  panelHeightPx = 310,
  offsetX = 12,
  offsetY = 12,
}: FloatingControlsHelpPanelProps) {
  return (
    <FloatingPanelShell
      open={open}
      onOpenChange={onOpenChange}
      triggerRef={triggerRef}
      title={title}
      panelWidthPx={panelWidthPx}
      panelHeightPx={panelHeightPx}
      offsetX={offsetX}
      offsetY={offsetY}
    >
      {children}
    </FloatingPanelShell>
  );
}
